// extracted by mini-css-extract-plugin
export default {"title":"oaa-z","warning":"paa-z","sizeOptionsLegendText":"qaa-z"};